import { FormattedMessage } from "react-intl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone, faEnvelope } from "@fortawesome/free-solid-svg-icons";

const TeacherSupportInfo = () => {
  return (
    <div
      className="d-flex flex-column justify-content-center align-items-center text-center p-4"
      style={{ height: "70vh" }}
    >
      <h3 className="fw-bold mb-3">
        <FormattedMessage id="NoClassesTitle" />
      </h3>

      <p style={{ fontSize: "1rem" }}>
        <FormattedMessage id="NoClassesInfo" />
      </p>

      <div className="d-flex align-items-center mb-1">
        <FontAwesomeIcon icon={faPhone} className="me-2 text-primary" />
        <span>0451-74 44 00</span>
      </div>

      <div className="d-flex align-items-center">
        <FontAwesomeIcon icon={faEnvelope} className="me-2 text-primary" />
        <span>support@pol.se</span>
      </div>
    </div>
  );
};

export default TeacherSupportInfo;
